import { useMemo, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getStatusColor, outletVendorColumns } from '../../../constants';
import { Table } from '../shared';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getBrand, brandsSelector } from '../../../store/slices';

const OutletVendor = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { brand, loading } = useAppSelector(brandsSelector);

  // Fetch brand data when component mounts
  useEffect(() => {
    if (slug) {
      dispatch(getBrand(slug));
    }
  }, [dispatch, slug]);

  // Transform brand kitchens to outlet vendor format
  const transformedOutlets = useMemo(() => {
    if (!brand?.kitchens) return [];

    return brand.kitchens.map((kitchen) => ({
      id: typeof kitchen.id === 'string' ? parseInt(kitchen.id) : kitchen.id,
      outletName: kitchen.name,
      outletOwner: kitchen.personOfContact || 'N/A',
      outletLocation: kitchen.address?.address || 'N/A',
      noOfUsers: kitchen.staffs?.length || 0,
      deliveryRadius: brand.coverageRadius || 0,
      status: kitchen.status === 'ACTIVE' ? 'Available' : 'Unavailable',
      createdAt: kitchen.createdAt,
      statusColor: getStatusColor(
        kitchen.status === 'ACTIVE' ? 'Available' : 'Unavailable'
      ),
    }));
  }, [brand]);
  // console.log('Transformed outlets:', transformedOutlets?.[0]?.id);

  const getVendorName = () => {
    return brand?.name || slug || 'Vendor';
  };

  return (
    <div className="body1">
      <div>
        <h1 className="text-3xl semibold text-gray-900">{getVendorName()}</h1>
      </div>
      <div className="flex justify-between items-center">
        <div className="my-4">
          <nav className="flex items-center space-x-2 text-sm">
            <button
              onClick={() => navigate('/dashboard/vendors')}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              Vendor
            </button>
            <span className="text-gray-400">&gt;</span>
            <span className="text-gray-900 font-medium">Outlets</span>
          </nav>
        </div>
        {/* Top Bar */}
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-4 justify-end w-full">
            {/* Export Button */}
            <button className="border border-neutral-300 rounded-lg px-4 py-2 text-sm bg-[#F3F4F6] flex items-center space-x-2">
              <span>↑</span>
              <span>Export</span>
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-8">
          <div className="text-gray-500">Loading outlets...</div>
        </div>
      ) : (
        <Table
          data={transformedOutlets as any}
          columns={outletVendorColumns}
          tableFor="outlets"
          showSearch={false}
          containerClassName="mt-0"
          theadClassName="bg-[#F0F1F3] !py-6 !px-3"
        />
      )}
    </div>
  );
};

export default OutletVendor;
